import url from 'url';

const formatTime = (time) => {
        const h = parseInt(String(time / 3600)),
            minute = parseInt(String((time / 60) % 60)),
            second = Math.ceil(time % 60),
            hours = h < 10 ? '0' + h : h,
            formatSecond = second > 59 ? 59 : second;
        return `${hours > 0 ? `${hours}:` : ''}${minute < 10 ? '0' + minute : minute}:${formatSecond < 10 ? '0' + formatSecond : formatSecond}`;
    },
    /**
     * 筛选html标签内的内容
     * @param html
     * @return {*|string}
     */
    filterHtml = (htmlString) => {
        // // const regex = /<[^>]*>([^<]*)<\/[^>]*>/; // 匹配HTML标签内的内容
        // const regex = /<([^>]+)>([^<]*)<\/\1>/g; // 匹配HTML标签内的内容
        // const match = regex.exec(html);
        // if (match) {
        //     const content = match[1]; // 获取匹配到的内容
        //     return content;
        // } else {
        //     return html;
        // }
        return htmlString.replace(/<[^>]*>/g, ''); // 使用正则表达式去除HTML标记
    },
    // import he from 'he';

    /**
     * html标签转义
     * @param htmlString
     * @return {*|string}
     */
    decodeHtml = (htmlString) => {
        const decodeHtml = htmlString.replace('&nbsp;', ' ').replace('&quot;', '"').replace('&amp;', '&').replace('&lt;', '<').replace('&gt;', '>');
        return decodeHtml;
    },
    /**
     * url截取query参数
     * @param urlStr   url地址
     * @return {*|string}
     */
    getUrlQueryMap = (urlStr) => {
        let urlObj = url.parse(urlStr),
            query = urlObj.query,
            queryMap = new Map();
        if (query !== null) {
            query.split('&').forEach((item) => {
                let arr = item.split('=');
                queryMap.set(arr[0], arr[1]);
            });
        }
        return queryMap;
    },
    /**
     * 字符串判空
     * @param obj
     * @return {boolean}
     */
    strIsEmpty = (obj) => {
        if (obj === undefined || obj === null || obj === '') {
            return true;
        }
        return false;
    };

// eslint-disable-next-line
Array.prototype.indexOf = function (val) {
    for (let i = 0; i < this.length; i++) {
        if (this[i] === val) return i;
    }
    return -1;
};
// eslint-disable-next-line
Array.prototype.remove = function (val) {
    let index = this.indexOf(val);
    if (index > -1) {
        this.splice(index, 1);
    }
};

export { formatTime, filterHtml, decodeHtml, getUrlQueryMap, strIsEmpty };
